export const firstBreakpointName = 'mobile';
export const breakpointNames = [firstBreakpointName, 'mobileXl', 'tablet', 'desktop'];
export const breakpoints = {
  mobile: 0,
  mobileXl: 375,
  tablet: 768,
  desktop: 992
};
export const isFirstBreakpoint = b => b === firstBreakpointName;
export const breakpointsDictMap = f => breakpointNames.reduce((c, b, i) => Object.assign(Object.assign({}, c), {
  [b]: f(b, i)
}), {});
export const breakpointsDictInit = a => breakpointsDictMap(() => a);
export const isBreakpointBelowOrEqual = (a, t) => {
  const aIndex = breakpointNames.indexOf(a);
  const tIndex = breakpointNames.indexOf(t);
  return aIndex <= tIndex;
};
export const breakpointFamilyFromBreakpoint = breakpoint => {
  switch (breakpoint) {
    case 'desktop':
    case 'tablet':
      return 'big';

    case 'mobileXl':
    case 'mobile':
      return 'small';
  }
};
//# sourceMappingURL=breakpoints.js.map